import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useSupport() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));



const getChatUserList = async (userid) => {
  try {
    const res = await api.post(
      "/Support/getChatUserList",
      { userid: String(userid || "") }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load users",
        data: [],
      };
    }
  } catch (e) {
    console.error("getChatUserList error:", e);
    return {
      success: false,
      message: "Error loading users",
      data: [],
    };
  }
};
const getSupportChatsAdmin = async ({
  mobile,
  message = "",
}) => {
  try {
    const res = await api.post(
      "/User/getSupportChatsAdmin",
      { mobile, message }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load chat",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getSupportChatsAdmin error:",
      e
    );
    return {
      success: false,
      message: "Error loading chat",
      data: [],
    };
  }
};
const sendSupportChatAdmin = async ({
  mobile,
  message,
}) => {
  try {
    const res = await api.post(
      "/User/sendSupportChatAdmin",
      { mobile, message }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Message sent",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to send",
      };
    }
  } catch (e) {
    console.error(
      "sendSupportChatAdmin error:",
      e
    );
    return {
      success: false,
      message: "Error sending message",
    };
  }
};
const getAllSupportTickets = async (userid) => {
  try {
    const res = await api.post(
      "/Support/v1.0/getAllSupportTicket",
      { userid: userid || "" }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load tickets",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getAllSupportTicket error:",
      e
    );
    return {
      success: false,
      message: "Error loading tickets",
      data: [],
    };
  }
};



  return {
    clients,
    orders,
    loading,
    busy,
    getChatUserList,
getSupportChatsAdmin,
sendSupportChatAdmin, 
getAllSupportTickets,



  };
}